export default __webpack_public_path__ + "static/media/math-multi-select.2e753a8a.gif";